import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en/translation.json';
import translationZH from './locales/zh/translation.json';

const resources = {
  en: { translation: translationEN },
  zh: { translation: translationZH },
  'zh-Hans': { translation: translationZH },
  'zh-hans': { translation: translationZH },
};

const detectionOptions = {
  order: ['localStorage', 'cookie', 'querystring', 'navigator', 'htmlTag'],
  lookupCookie: 'django_language',
  caches: ['localStorage', 'cookie'],
  cookieMinutes: 365 * 24 * 60,
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'zh', 'zh-Hans', 'zh-hans'],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    detection: detectionOptions,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
